import { useQuery } from "urql";

import { CopyToClipboardButton } from "@/components/CopyToClipboardButton";
import { graphql } from "@/gen";
import { PlayerForm } from "@/routes/players/components/PlayerForm";
import { CountryCode, countryNamesByCodes } from "@/utils/i18n";

const usePlayer = (playerId: string) => {
    const [result, refetch] = useQuery({
        query: graphql(`
            query playerQuery($id: UUID!) {
                player(id: $id) {
                    id
                    fideId
                    name
                    createdAt
                    updatedAt
                    fideRatingStandard
                    fideTitle
                    countryCode
                    ...PlayerForm_Player
                }
            }
        `),
        variables: {
            id: playerId,
        },
    });

    return {
        player: result.data?.player,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};
export const Player = ({ id }: { id: string }) => {
    const { player, loading, error } = usePlayer(id);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (!player) {
        return <p>Player not found</p>;
    }

    return (
        <div className="flex flex-col gap-12 py-4 pr-2">
            <div className="flex items-start justify-between">
                <div className="flex flex-col">
                    <span className="text-lg font-bold">{player.name}</span>
                    <div className="flex-row items-center">
                        <span className="text-sm">ID: {player.id}</span>
                        <CopyToClipboardButton text={player.id} />
                    </div>
                    {player.fideId ? (
                        <div className="flex-row items-center gap-8">
                            <span className="text-sm">FIDE ID: {player.fideId}</span>
                            <CopyToClipboardButton text={player.fideId.toString()} />
                        </div>
                    ) : null}
                    {player.fideId ? (
                        <div className="flex-row items-center gap-8">
                            <span className="text-sm">
                                FIDE rating: {player.fideRatingStandard}
                            </span>
                        </div>
                    ) : null}
                    {player.countryCode ? (
                        <div className="flex-row items-center gap-8">
                            <span className="text-sm">
                                Country: {countryNamesByCodes[player.countryCode as CountryCode]}
                            </span>
                        </div>
                    ) : null}
                </div>
            </div>
            <PlayerForm key={player.id} playerFragment={player} />
        </div>
    );
};
